<template>
    <div class="artist">
        <b-row class="m-2">
            <b-col class="gallery">
                <img src="@/assets/images/knitted.jpeg" alt="">
                <img src="@/assets/images/girls.jpg" alt="">
                <img src="@/assets/images/girl.jpg" alt="">
                <img src="@/assets/images/girl2.jpg" alt="">
                <img src="@/assets/images/digital.jpg" alt="">
            </b-col>
        </b-row>
        <b-row class="m-2">
            <b-col>
                <b-link to="/engineer">Engineer</b-link>
            </b-col>
            <b-col class="text-right">
                <b-link to="/">Home</b-link>
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
    name: 'Artist',
    components: {},
    data() {
        return {}
    },
}
</script>  

<style>

</style>  